// Module
var code = `<div class="card">
	<div class="card-header" ng-click="\$ctrl.isCollapsed = !\$ctrl.isCollapsed"
		style="cursor: pointer;border-bottom: 3px solid {{\$ctrl.scene.color}} !important;">
		<span class="h4 card-title">
			<i class="fas fa-fw"
				ng-class="{'fa-chevron-right': \$ctrl.isCollapsed, 'fa-chevron-down': !\$ctrl.isCollapsed}"></i> Status
			<span
				style="display: inline-block; width: 10px; height: 10px; border-radius: 50%; margin-left: 8px; vertical-align: middle;"
				ng-style="{'background-color': \$ctrl.isOnline ? '#38a169' : '#e53e3e'}"
				title="{{\$ctrl.isOnline ? 'Online' : 'Offline'}}"></span>
		</span>
	</div>
	<div class="card-body" ng-show="!\$ctrl.isCollapsed">
		<div>
			<span
				style="display: inline-block; width: 8px; height: 8px; border-radius: 50%; margin-right: 6px; vertical-align: middle;"
				ng-style="{'background-color': \$ctrl.isOnline ? '#38a169' : '#e53e3e'}"></span>
			<strong ng-if="\$ctrl.isOnline" style="color: #38a169;">Online</strong>
			<strong ng-if="!\$ctrl.isOnline" style="color: #e53e3e;">Offline</strong>
		</div>
		<div>Version: {{\$ctrl.scene.version | jumbotronVersionJson}} {{\$ctrl.abc}}</div>
		<div>
			<span>Last seen:&nbsp;</span>
			<span>{{\$ctrl.scene.lastSeen | amFromUnix | amDateFormat:'YYYY-MM-DD HH:mm:ss'}}&nbsp;</span>
			<span am-time-ago="\$ctrl.scene.lastSeen | amFromUnix"></span>
		</div>
		<div class="d-flex justify-content-end">
			<button title="Settings" ui-sref="manager.scene-edit({id:\$ctrl.scene.id})" class="btn btn-outline-primary">
				<i class="fa fa-cog"></i>
			</button>
		</div>
	</div>
</div>`;
// Exports
export default code;